import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery, gql } from '@zenbusiness/application-commons-graphql';

import {
  getOrderTaskByGroup,
  getOrderTaskByType
} from '#client/utils/orderTask';

import Accounting from './Accounting';

export const GET_ACCOUNTING_QUERY = gql`
  query AccountingQuery($businessEntityUuid: UUID!) {
    orderTasksLegacy(businessEntityUuid: $businessEntityUuid) {
      orderTasksLegacy {
        orderTaskType
        orderTaskStatus
        createdDatetime
      }
    }
  }
`;

const Renderer = () => {
  const { businessEntityUuid } = useBusinessEntity();
  const { loading, data = {} } = useQuery(
    GET_ACCOUNTING_QUERY,
    {
      variables: {
        businessEntityUuid
      }
    }
  );

  const {
    orderTasksLegacy: {
      orderTasksLegacy = []
    } = {}
  } = data;

  const accountingOrderTask = !loading ? getOrderTaskByGroup(orderTasksLegacy, 'accounting') : null;
  const cpaAssessmentOrderTask = !loading ? getOrderTaskByType(orderTasksLegacy, 'initial_cpa_screening') : null;

  return (
    <Accounting
      loading={loading}
      businessEntityUuid={businessEntityUuid}
      accountingOrderTask={accountingOrderTask}
      cpaAssessmentOrderTask={cpaAssessmentOrderTask}
    />
  );
};

export default Renderer;
